<template>
  <div class="join-us">
    <div class="join-us-box">
      <div class="join-us-text">加入我们</div>
      <p class="d-none d-md-block">
        和世界一流的WebRTC工程师团队并肩
        <br />
        打造新一代视频原生的企业信息化基础设施
      </p>
      <p class="d-md-none">
        和世界一流的WebRTC工程师团队并肩
        <br />
        打造新一代视频原生的
        <br />
        企业信息化基础设施
      </p>
      <ContactBtn :customBtnClick="handleJoin" width="200px" height="60px" fontSize="24px">
        <template v-slot:default> 查看职位空缺 </template>
      </ContactBtn>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        a: 1,
      };
    },
    created() {},
    mounted() {},
    methods: {
      handleJoin() {
        this.$router.push({ path: "/join" });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .join-us {
    text-align: center;

    .join-us-box {
      display: inline-block;
      margin: 120px 0;

      .join-us-text {
        position: relative;
        color: $main-color;
        font-size: 44px;
        font-weight: bold;

        &::before {
          content: "";
          position: absolute;
          top: -66px;
          left: 20px;
          display: inline-block;
          width: 142px;
          height: 132px;
          background-image: url("~assets/img/about/join-us1.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }

      p {
        position: relative;
        margin-top: 40px;
        color: #333;
        font-size: 32px;

        &::after {
          content: "";
          position: absolute;
          right: 0;
          bottom: -109px;
          display: inline-block;
          width: 104px;
          height: 109px;
          background-image: url("~assets/img/about/join-us2.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }

      .contact-btn {
        margin-top: 40px;
      }
    }
  }

  @media screen and (max-width: 992px) {
  }

  @media screen and (max-width: 768px) {
    .join-us {
      // text-align: center;
      .join-us-box {
        // display: inline-block;
        margin: 50px 0;

        .join-us-text {
          font-size: 16px;

          // position: relative;
          &::before {
            position: unset;
            // left: 0;
            // top: 0;
            margin-left: -38px;
            // content: "";
            // display: inline-block;
            width: 38px;
            height: 38px;
            // background-image: url("~assets/img/about/join-us1.png");
            // background-repeat: no-repeat;
            // background-size: 100% 100%;
          }
        }

        p {
          // width: 239px;
          margin-top: unset;
          color: #333;
          font-size: 14px;

          // position: relative;
          &::after {
            // position: absolute;
            right: 8px;
            bottom: -20px;
            // content: "";
            display: inline-block;
            width: 28px;
            height: 28px;
            // background-image: url("~assets/img/about/join-us2.png");
            // background-repeat: no-repeat;
            // background-size: 100% 100%;
          }
        }

        .contact-btn {
          margin-top: 27px;

          ::v-deep button {
            width: 130px !important;
            height: 30px !important;
            font-size: 17px !important;
          }
        }
      }
    }
  }
</style>
